import { render, staticRenderFns } from "./Uml2.vue?vue&type=template&id=5ca10a3c&scoped=true&"
import script from "./Uml2.vue?vue&type=script&lang=js&"
export * from "./Uml2.vue?vue&type=script&lang=js&"
import style0 from "./Uml2.vue?vue&type=style&index=0&id=5ca10a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca10a3c",
  null
  
)

export default component.exports